/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kibumbwe 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bwenda": ["Munyinya", "Murambi", "Murwa", "Nyagatovu", "Nyamirama"],
  "Gakanka": ["Cyeru", "Gikomero", "Munini", "Nkurubuye", "Nyarubuye", "Rambya"],
  "Kibibi": ["Gatandaganya", "Kabere", "Kanyege", "Kirwa", "Rwezamenyo", "Ryingarura"],
  "Nyakiza": ["Dusenyi", "Karambo", "Kinyana", "Murambi", "Nyakizu", "Zigati"]
};